import { getCookies } from "../../../../services/Cookies";

export const addJournalLog = (type, message) => {
    //   const clientId = getCookies("clientId") ||localStorage.getItem('clientId');
    const clientId = getCookies("clientId")

    const log = {
        id: Date.now(),
        time: new Date().toISOString(),
        day: new Date().toISOString().split("T")[0],
        type,
        message,
        clientId: clientId,
        account_id: localStorage.getItem("accountID")
    };

    const existing = JSON.parse(localStorage.getItem("journalData") || "[]");
    existing.push(log);
    localStorage.setItem("journalData", JSON.stringify(existing));
    localStorage.setItem("journalLastUpdatedDate", log.day);

};

